<template>
  <div class="empty-table-message">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'EmptyTableMessage'
}
</script>

<style scoped lang="scss">
.empty-table-message {
  margin-bottom: 1em;
  text-align: center;
}
</style>
